import { css } from "emotion";

export const container = css`
    display: flex;
    align-items: center;
`;

export const text = css`
    margin-right: 25px;
    font-weight: 700;
    font-size: 15px;
    flex-shrink: 0;
`;

export const stars = css`
    flex-shrink: 0;
    margin-right: 10px;
`;

export const validationLabel = css`
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
`;

export const message = css`
    flex-shrink: 0;
`;